const DashboardNavData = [
    {
        title: "Dashboard",
        link: "/dashboard",
        
    },
    {
        title: "General Training",
        link: "/dashboard/general-training"
    },
    {
        title: "Positional Training",
        link: "/dashboard/positional-training"
    },
    {
        title: "Quiz",
        link: "/quiz/main"
    }
];

export default DashboardNavData;